import Flickity from 'flickity';

export default {
  init($element) {
  },
  finalize($element) {

    if ($element.find('.destinations-carousel')) {
      const destinationsCarousel = new Flickity($element.find('.destinations-carousel').get()[0], {
        adaptiveHeight: true,
        autoPlay: false,
        prevNextButtons: false,
        pageDots: false,
        contain: true,
        lazyLoad: true,
        on: {
          ready: function() {
            window.dispatchEvent(new Event('resize')); // Quickfix for sizing issue

            // Accommodating for pesky iOS devices..
            // $('.destinations-wrap').css({ 'min-height': ($(window).height() * 0.9) + 'px' });
          },
        },
      });

      destinationsCarousel.on('change', function(i) {
        $element.find('.destinations-carousel').data('i', i);

        if (i == 0) {
          $element.find('.destination-slide-arrow-prev').removeClass('active');
        } else {
          $element.find('.destination-slide-arrow-prev').addClass('active');

          if (i + 1 >= destinationsCarousel.slides.length) {
            $element.find('.destination-slide-arrow-next').removeClass('active');
          } else {
            $element.find('.destination-slide-arrow-next').addClass('active');
          }
        }

        // We want to cache the height of the details panel
        const currentHeight = $element.find('.destinations-details-inner').outerHeight();
        $element.find('.destinations-details-inner').css({ height: currentHeight + 'px' });
        $element.find('.destination-detail').removeClass('show').addClass('hiding');

        setTimeout(() => {
          $element.find('.destination-detail.hiding').removeClass('hiding is-static');

          if ($element.find('.destinations-carousel').data('i') == i) {
            $element.find(`.destination-detail[data-detail-key="${i}"]`).addClass('show is-static');
            $element.find('.destinations-details-inner').css({ height: 'initial' });
          }
        }, 600);
      });

      $element.find('.destination-slide-arrow-prev').on('click', function() {
        destinationsCarousel.previous();
      });

      $element.find('.destination-slide-arrow-next').on('click', function() {
        destinationsCarousel.next();
      });
    }
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/shared/destinations.js